import { useTranslation } from "react-i18next";
import clsx from "clsx";

import { Icon } from "../icons";
import { Typography } from "../typography";

import { infoBoxVariantValues } from "./variant";
import classes from "./styles.module.scss";

import type { IInfoBoxProps } from ".";

import { mergeProps } from "@/utils";

export function InfoBox(props: IInfoBoxProps) {
  const { type, ...rest } = props;
  const mergedProps = mergeProps(rest, infoBoxVariantValues[type]);
  const { icon, translatedText, text, fullWidth } = mergedProps;

  const { t } = useTranslation("form");

  return (
    <div
      className={clsx([
        classes.container,
        fullWidth && "w-100",
        "p-m1 gap-xs1",
      ])}
    >
      {icon && (
        <div className={"d-inline-flex"}>
          <Icon name={icon} color={"warning-main"} />
        </div>
      )}
      <Typography color={"inherit"}>
        {translatedText ? t(translatedText) : text}
      </Typography>
    </div>
  );
}
